// ---------------------------------------------------------------------------
// Which screen the user is on, in the terms Copilot understands.
//
// Sent with every turn as `osavul_context`. It is a hint: Copilot uses it to pick the tools that
// fit the screen and to tell the model where the user is; it grants nothing.
// ---------------------------------------------------------------------------

const CUSTOM_DASHBOARD_RE = /^\/custom-dashboards\/([^/]+)/;

/**
 * `{surface, path, dashboardId, narrativeId}` for the current location.
 *
 * `page` is what a case page registered with useCopilotMinPage (the case on screen), or null.
 * surface: 'case' on a case page, 'dashboard' on a custom dashboard, 'search' everywhere else.
 */
export function screenOf(pathname, page) {
  const narrativeId = page?.narrativeId ?? null;
  const dashboardId = CUSTOM_DASHBOARD_RE.exec(pathname)?.[1] ?? null;
  if (narrativeId) return { surface: 'case', path: pathname, dashboardId: null, narrativeId };
  if (dashboardId) return { surface: 'dashboard', path: pathname, dashboardId, narrativeId: null };
  return { surface: 'search', path: pathname, dashboardId: null, narrativeId: null };
}

/** The `osavul_context` object for a request body. */
export function osavulContextOf(screen) {
  // The API caps the path at 300 characters; a longer one would reject the whole turn.
  const context = { surface: screen.surface, path: screen.path.slice(0, 300) };
  if (screen.dashboardId) context.dashboard_id = screen.dashboardId;
  return context;
}
